export default {"src":"/_next/static/media/sepa.c9e823a4.svg","height":41,"width":41,"blurWidth":0,"blurHeight":0};